import { apiClient } from './client';

export interface AgentLogDto {
  id: number;
  agentId: number;
  agentName: string;
  level: string;
  message: string;
  details: string | null;
  source: string | null;
  createdAt: string;
}

export interface AgentLogsResponse {
  data: AgentLogDto[];
  pagination: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

export interface LogStats {
  byLevel: { level: string; count: number }[];
  byHour: { hour: string; count: number }[];
}

export const agentLogsApi = {
  getLogs: async (
    firmId: number,
    params?: {
      agentId?: number;
      level?: string;
      source?: string;
      from?: string;
      to?: string;
      search?: string;
      page?: number;
      pageSize?: number;
    }
  ): Promise<AgentLogsResponse> => {
    const response = await apiClient.get(`/api/firms/${firmId}/logs`, { params });
    return response.data;
  },

  getStats: async (firmId: number, hours?: number): Promise<LogStats> => {
    const response = await apiClient.get(`/api/firms/${firmId}/logs/stats`, {
      params: { hours },
    });
    return response.data;
  },

  getLevels: async (firmId: number): Promise<string[]> => {
    const response = await apiClient.get(`/api/firms/${firmId}/logs/levels`);
    return response.data;
  },

  getSources: async (firmId: number): Promise<string[]> => {
    const response = await apiClient.get(`/api/firms/${firmId}/logs/sources`);
    return response.data;
  },

  clearLogs: async (firmId: number, olderThanDays?: number): Promise<{ deleted: number }> => {
    const response = await apiClient.delete(`/api/firms/${firmId}/logs`, {
      params: { olderThanDays },
    });
    return response.data;
  },
};
